import { Receipt, FileText, RefreshCw, ArrowUpRight } from 'lucide-react';

const CARDS = [
  { id: 'create-paystub', icon: Receipt, title: 'Create a Paystub', desc: 'Start a new stub or pick a saved client below.', accent: 'text-amber-400 border-amber-500/40 hover:border-amber-400' },
  { id: 'create-w2', icon: FileText, title: 'Create a W-2', desc: 'From scratch, or carry a prior year\u2019s W-2 forward.', accent: 'text-emerald-400 border-emerald-500/40 hover:border-emerald-400' },
  { id: 'update-paystub', icon: RefreshCw, title: 'Update an Existing Paystub', desc: 'Upload a stub, move it to new dates, recalc YTD.', accent: 'text-sky-400 border-sky-500/40 hover:border-sky-400' },
];

export const PaydayHub = ({ onSelect }) => (
  <div className="grid md:grid-cols-3 gap-3 mb-6" data-testid="payday-hub">
    {CARDS.map((c, i) => (
      <button
        key={c.id}
        type="button"
        onClick={() => onSelect(c.id)}
        data-testid={`hub-${c.id}`}
        style={{ animationDelay: `${i * 70}ms` }}
        className={`group text-left p-5 rounded-2xl bg-zinc-900 border-2 ${c.accent} transition-[transform,border-color] duration-200 hover:-translate-y-0.5 animate-in fade-in slide-in-from-bottom-2`}
      >
        <div className="flex items-start justify-between">
          <c.icon className="w-7 h-7" />
          <ArrowUpRight className="w-4 h-4 text-zinc-600 group-hover:text-zinc-300 transition-colors" />
        </div>
        <p className="text-white font-bold text-lg mt-4">{c.title}</p>
        <p className="text-xs text-zinc-400 mt-1">{c.desc}</p>
      </button>
    ))}
  </div>
);
